import {useEffect, useRef} from "react";

interface UseApplicationMultiLeadSwitchViewFocusParams {
    showPropertiesList: boolean;
    setShowPropertiesList: (showPropertiesList: boolean) => void;
}

export const useApplicationMultiLeadSwitchViewFocus = (params: UseApplicationMultiLeadSwitchViewFocusParams) => {
    const {showPropertiesList, setShowPropertiesList} = params;

    const propertyListRef = useRef<HTMLDivElement>(null);
    const showPropertiesListButtonRef = useRef<HTMLButtonElement>(null);
    const shouldFocusSwitchedViewRef = useRef(false);

    const switchView = (nextShowPropertiesList: boolean) => {
        shouldFocusSwitchedViewRef.current = true;
        setShowPropertiesList(nextShowPropertiesList);
    };

    useEffect(() => {
        if (!shouldFocusSwitchedViewRef.current) {
            return;
        }

        shouldFocusSwitchedViewRef.current = false;

        const focusTarget = showPropertiesList
            ? (propertyListRef.current?.querySelector<HTMLInputElement>("input[type='checkbox']") ??
              propertyListRef.current?.closest<HTMLElement>("[role='dialog']"))
            : showPropertiesListButtonRef.current;

        focusTarget?.focus();
    }, [showPropertiesList]);

    return {propertyListRef, showPropertiesListButtonRef, switchView};
};
import {useEffect, useRef} from "react";

interface UseApplicationMultiLeadSwitchViewFocusParams {
    showPropertiesList: boolean;
    setShowPropertiesList: (showPropertiesList: boolean) => void;
}

export const useApplicationMultiLeadSwitchViewFocus = (params: UseApplicationMultiLeadSwitchViewFocusParams) => {
    const {showPropertiesList, setShowPropertiesList} = params;

    const propertyListRef = useRef<HTMLDivElement>(null);
    const showPropertiesListButtonRef = useRef<HTMLButtonElement>(null);
    const shouldFocusSwitchedViewRef = useRef(false);

    const switchView = (nextShowPropertiesList: boolean) => {
        shouldFocusSwitchedViewRef.current = true;
        setShowPropertiesList(nextShowPropertiesList);
    };

    useEffect(() => {
        if (!shouldFocusSwitchedViewRef.current) {
            return;
        }

        shouldFocusSwitchedViewRef.current = false;

        const focusTarget = showPropertiesList
            ? (propertyListRef.current?.querySelector<HTMLInputElement>("input[type='checkbox']") ??
              propertyListRef.current?.closest<HTMLElement>("[role='dialog']"))
            : showPropertiesListButtonRef.current;

        focusTarget?.focus();
    }, [showPropertiesList]);

    return {propertyListRef, showPropertiesListButtonRef, switchView};
};
